import React from 'react';
import { motion } from 'framer-motion';
import { Award, CheckCircle2, MapPin, Clock, Phone } from 'lucide-react';

const AboutUs = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-white to-gray-100">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto"
        >
          <div className="text-center mb-12">
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              className="flex justify-center mb-6"
            >
              <Award className="h-16 w-16 text-dk-blue" />
            </motion.div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
              Votre Expert en Diagnostics Immobiliers
            </h2>
            <p className="text-lg text-gray-600">
              Une expertise locale au service de vos projets immobiliers
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
            <div className="prose prose-lg max-w-none text-gray-700">
              <p className="mb-6 leading-relaxed">
                Bienvenue chez DIAGNOSTI-K. Pierre Siepielski, votre diagnostiqueur immobilier certifié à Camaret-sur-Aigues, 
                mets son expertise technique et sa connaissance approfondie du territoire au service de vos projets immobiliers.
              </p>
              <p className="mb-6 leading-relaxed">
                Mon engagement : vous accompagner avec professionnalisme et rigueur dans la réalisation de tous 
                vos diagnostics obligatoires, que ce soit pour une vente, une location ou des travaux.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
              <div className="bg-gray-50 rounded-lg p-6">
                <h3 className="text-xl font-semibold mb-4 text-gray-900">Notre Expertise</h3>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <CheckCircle2 className="h-5 w-5 text-dk-blue mt-1 mr-3 flex-shrink-0" />
                    <span>Diagnostiqueur certifié et assuré</span>
                  </li>
                  <li className="flex items-start">
                    <CheckCircle2 className="h-5 w-5 text-dk-blue mt-1 mr-3 flex-shrink-0" />
                    <span>Rapports détaillés et professionnels</span>
                  </li>
                  <li className="flex items-start">
                    <CheckCircle2 className="h-5 w-5 text-dk-blue mt-1 mr-3 flex-shrink-0" />
                    <span>Équipements de mesure dernière génération</span>
                  </li>
                  <li className="flex items-start">
                    <CheckCircle2 className="h-5 w-5 text-dk-blue mt-1 mr-3 flex-shrink-0" />
                    <span>Formation continue aux nouvelles normes</span>
                  </li>
                </ul>
              </div>

              <div className="bg-gray-50 rounded-lg p-6">
                <h3 className="text-xl font-semibold mb-4 text-gray-900">Nos Engagements</h3>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <CheckCircle2 className="h-5 w-5 text-dk-blue mt-1 mr-3 flex-shrink-0" />
                    <span>Disponibilité et réactivité</span>
                  </li>
                  <li className="flex items-start">
                    <CheckCircle2 className="h-5 w-5 text-dk-blue mt-1 mr-3 flex-shrink-0" />
                    <span>Devis gratuit et transparent</span>
                  </li>
                  <li className="flex items-start">
                    <CheckCircle2 className="h-5 w-5 text-dk-blue mt-1 mr-3 flex-shrink-0" />
                    <span>Conseils personnalisés</span>
                  </li>
                  <li className="flex items-start">
                    <CheckCircle2 className="h-5 w-5 text-dk-blue mt-1 mr-3 flex-shrink-0" />
                    <span>Suivi complet de votre dossier</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-dk-blue text-white rounded-lg shadow-lg p-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="flex items-start space-x-4">
                <MapPin className="h-6 w-6 flex-shrink-0" />
                <div>
                  <h4 className="font-semibold mb-2">Zone d'intervention</h4>
                  <p className="text-white/90">Camaret-sur-Aigues et environs</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <Clock className="h-6 w-6 flex-shrink-0" />
                <div>
                  <h4 className="font-semibold mb-2">Horaires</h4>
                  <p className="text-white/90">Lun-Ven : 8h-19h<br />Sam : Sur RDV</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <Phone className="h-6 w-6 flex-shrink-0" />
                <div>
                  <h4 className="font-semibold mb-2">Contact</h4>
                  <a href="tel:0789307500" className="text-white/90 hover:text-white">
                    07 89 30 75 00
                  </a>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutUs;